import { render, staticRenderFns } from "./status.vue?vue&type=template&id=041d6fb2&scoped=true&"
var script = {}
import style0 from "./status.vue?vue&type=style&index=0&id=041d6fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041d6fb2",
  null
  
)

export default component.exports